import { ArrowRight, Building2, ClipboardCheck, Package2, PanelsTopLeft, PhoneCall, Truck } from "lucide-react";
import { PHOTOS } from "@/lib/site";

const advantages = [
  { icon: Building2, label: "Jaringan Distribusi" },
  { icon: PhoneCall, label: "Dukungan Tim Sales" },
  { icon: Truck, label: "Pengiriman Nasional" },
  { icon: ClipboardCheck, label: "Respons Kebutuhan Proyek" },
  { icon: PanelsTopLeft, label: "Portofolio Aplikasi" },
  { icon: Package2, label: "Pasokan Multi Produk" },
];

export const Hero = () => {
  return (
    <section
      id="beranda"
      data-testid="hero-section"
      className="relative min-h-screen pt-32 pb-24 overflow-hidden"
    >
      <div className="absolute inset-0 hero-radial" />
      <div className="absolute inset-0 grid-pattern opacity-40" />
      <div className="absolute inset-0">
        <img
          src={PHOTOS.kantorDisplay}
          alt="Kantor Display PT Animax Putra Lancar"
          className="w-full h-full object-cover object-center opacity-[0.72]"
          style={{
            WebkitMaskImage: "linear-gradient(to right, transparent 0%, rgba(0,0,0,0.18) 34%, rgba(0,0,0,0.72) 62%, black 100%)",
            maskImage: "linear-gradient(to right, transparent 0%, rgba(0,0,0,0.18) 34%, rgba(0,0,0,0.72) 62%, black 100%)",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/70 to-background/10" />
        <div className="absolute inset-0 bg-gradient-to-b from-background/75 via-transparent to-background" />
        <div className="absolute inset-0 bg-animax-yellow/10" />
      </div>

      <div className="max-w-7xl mx-auto px-6 relative">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full glass-light mb-6" data-testid="hero-badge">
              <div className="w-2 h-2 rounded-full bg-animax-orange animate-pulse" />
              <span className="tag-uppercase text-neutral-700">PT. Animax Putra Lancar</span>
            </div>

            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl xl:text-7xl leading-[1.05] tracking-tighter font-medium text-animax-black">
              Solusi Material untuk{" "}
              <span className="relative inline-block">
                <span className="relative z-10">Proyek & Industri</span>
                <span className="absolute bottom-1 left-0 right-0 h-3 bg-animax-yellow -z-0 opacity-80" />
              </span>
            </h1>

            <p className="mt-6 text-base sm:text-lg text-neutral-600 leading-relaxed max-w-2xl">
              Menyediakan pilihan material dan produk pendukung untuk kebutuhan proyek, kontraktor,
              retail, display, interior, hingga industri dengan layanan responsif dan dukungan tim
              sales yang mudah dihubungi.
            </p>

            <div className="mt-10 flex flex-wrap gap-4">
              <a
                href="/#produk"
                data-testid="hero-cta-product"
                className="group inline-flex items-center gap-2 px-7 py-4 rounded-full bg-animax-orange text-white font-medium text-sm hover:bg-animax-yellow hover:text-animax-black transition-all shadow-lg shadow-animax-orange/25"
              >
                <Package2 className="w-4 h-4" />
                Lihat Produk Kami
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </a>
              <a
                href="/#kontak"
                data-testid="hero-cta-quote"
                className="inline-flex items-center gap-2 px-7 py-4 rounded-full border border-animax-black text-animax-black font-medium text-sm hover:bg-animax-black hover:text-white transition-all"
              >
                Hubungi PT APL
                <ArrowRight className="w-4 h-4" />
              </a>
            </div>

            <div className="mt-12 flex items-center gap-8">
              <div>
                <div className="font-display text-3xl font-medium text-animax-black">2021</div>
                <div className="tag-uppercase text-neutral-500 mt-1">Berdiri Sejak</div>
              </div>
              <div className="w-px h-10 bg-neutral-300" />
              <div>
                <div className="font-display text-3xl font-medium text-animax-black">APL</div>
                <div className="tag-uppercase text-neutral-500 mt-1">Trading & Distribusi</div>
              </div>
              <div className="w-px h-10 bg-neutral-300" />
              <div>
                <div className="font-display text-3xl font-medium text-animax-black">Mojokerto</div>
                <div className="tag-uppercase text-neutral-500 mt-1">Jawa Timur</div>
              </div>
            </div>
          </div>

          <div className="hidden lg:block lg:col-span-5" data-testid="hero-visual" />
        </div>

        <div className="mt-24 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {advantages.map((a, i) => (
            <div
              key={i}
              data-testid={`hero-advantage-${i}`}
              className="card-lift group p-5 rounded-2xl bg-white border border-neutral-200/70"
            >
              <div className="w-10 h-10 rounded-lg bg-neutral-100 flex items-center justify-center mb-3 group-hover:bg-animax-yellow transition-colors">
                <a.icon className="w-5 h-5 text-animax-black" />
              </div>
              <div className="text-sm font-medium text-animax-black leading-snug">{a.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
